import { Button, Card, CardActions, CardContent, CardHeader, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { formatCurrency, Loader, postMessageToParent, renderStringAsHtml } from '../../libs/helpers';

class SimilarCampaigns extends React.Component {
    state = { loading: false }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    performInstantSeedAction = (slug) => {
        return async () => {
            this.setState({ loading: slug });
            this.props.performInstantSeedAction(slug);
        }
    }
    /* API Call */
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    onReadMoreClicked = (url) => {
        return () => {
            postMessageToParent('redirect', { url });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.state.loading && !this.props.instantDonate) {
            this.setState({ loading: false })
        }
    }
    /* Render Page */
    render() {
        let { data } = this.props;
        let { loading } = this.state;
        return (
            <div className="fullwidth tmargin-20">
                <Grid container justify='space-between'>
                    <Typography style={{ fontWeight: 700, fontSize: '18px' }} gutterBottom>
                        Fund other campaigns
                    </Typography>
                    {/*  <Typography style={{ fontSize: '14px', color: '#7BC57F' }}>
                        all campaigns
                    </Typography> */}
                </Grid>
                {Array.isArray(data) && data.map((item) => {
                    return (
                        <Card className="bmargin-20"
                            style={{
                                backgroundColor: '#fff',
                                boxShadow: '0 7px 19px 6px rgba(204, 216, 225, 0.14)',
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <CardHeader
                                avatar={
                                    <img alt={item.student.name} src={item.student.image_url}
                                        style={{ width: '60px', maxWidth: '60px' }} />
                                }
                                style={{ paddingBottom: '0px' }}
                                title={item.student.name}
                                subheader={(item.education.prospected_major ? item.education.prospected_major.name : '')}
                            />
                            <CardContent>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {renderStringAsHtml(item.statement.life_story.substr(0, 120) + '...')}
                                </Typography>
                            </CardContent>
                            <CardActions style={{ justifyContent: 'space-between' }}>
                                {/* <Grid container xs={4}>
                                    <Button style={{ maxWidth: '30px' }}>
                                        <ArrowUpward style={{ fontSize: '14px' }} />
                                    </Button>
                                    <Button style={{ maxWidth: '30px' }}>
                                        <ArrowDownward style={{ fontSize: '14px' }} />
                                    </Button>
                                </Grid> */}
                                <Grid container style={{ justifyContent: 'flex-end' }}>
                                    <Button style={{ fontSize: '14px', textTransform: 'none' }} disabled={loading} onClick={this.onReadMoreClicked(item.public_url)}>
                                        View
                                    </Button>
                                    <Button style={{ color: '#7BC57F', textTransform: 'none', fontSize: '14px', }} disabled={loading} onClick={this.performInstantSeedAction(item.slug)}>
                                        {loading === item.slug ? <Loader size='20' /> : "Donate $" + formatCurrency(this.props.amount)}
                                    </Button>
                                </Grid>
                            </CardActions>
                        </Card>
                    );
                })}

            </div>
        );
    }
}

export default SimilarCampaigns;